module.exports = global["_"] = require("-!./lodash.js");


//////////////////
// WEBPACK FOOTER
// ../~/lodash/lodash.js-exposed
// module id = 205
// module chunks = 3